import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccount from './account.reducer';

export const selectAccountState = createFeatureSelector<fromAccount.AccountState>(
  fromAccount.accountFeatureKey
);

export const selectUser = createSelector(
  selectAccountState,
  state => state.user
);

export const selectLoading = createSelector(
  selectAccountState,
  state => state.loading
);

export const selectError = createSelector(
  selectAccountState,
  state => state.error
);

export const selectUserId = createSelector(
  selectUser,
  user => user?.id || null
);
